/**
 * Shared React Query key factory i hook-ovi za organization detail API-je.
 * Koristi se za dodatne informacije o organizaciji (kontakt osoba).
 */

import { useQuery } from '@tanstack/react-query';
import OrganizationService from '@/shared/services/OrganizationService';

/** Query key factory za organization keš. */
export const organizationKeys = {
  all: ['organization'],
  additionalInfo: (organizationId) => [...organizationKeys.all, 'additionalInfo', organizationId],
};

const STALE_TIME_MS = 60 * 1000;

/**
 * React Query hook za dodatne informacije organizacije (kontakt osoba).
 *
 * @param {string|number} organizationId - ID organizacije.
 * @param {import('@tanstack/react-query').UseQueryOptions} [options] - Dodatne React Query opcije.
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useOrganizationAdditionalInfoQuery(organizationId, options = {}) {
  return useQuery({
    queryKey: organizationKeys.additionalInfo(organizationId),
    queryFn: () => OrganizationService.searchAdditionalInfo(organizationId),
    enabled: Boolean(organizationId),
    staleTime: STALE_TIME_MS,
    ...options,
  });
}
